import { useEffect } from "react";
import { BrowserRouter, Navigate, Outlet, Route, Routes, useLocation } from "react-router-dom";
import "../src/assets/sass/style.scss";
import store from "./Redux/store";
import Home from "./component/Home/Home";
import { Provider } from "react-redux";
import Header from "./component/Header/Header";
import Footer from "./component/Footer/Footer";
import Login from "./component/Admin/Login/Login";
import AdminLayout from "./component/Admin/Layout/AdminLayout";
import ProtectedRoute from "./component/Admin/ProtectedRoute";
import Dashboard from "./component/Admin/Dashboard/Dashboard";
import HomeContentManager from "./component/Admin/HomeContent/HomeContentManager";
import ServicesManager from "./component/Admin/Services/ServicesManager";
import TeamManager from "./component/Admin/Team/TeamManager";
import BlogManager from "./component/Admin/Blog/BlogManager";
import CoreValuesManager from "./component/Admin/CoreValues/CoreValuesManager";
import InsuranceManager from "./component/Admin/Insurance/InsuranceManager";
import ConditionsManager from "./component/Admin/Conditions/ConditionsManager";
import SettingsManager from "./component/Admin/Settings/SettingsManager";
import BookingsManager from "./component/Admin/Bookings/BookingsManager";
import LocationsManager from "./component/Admin/Locations/LocationsManager";
import FAQManager from "./component/Admin/FAQ/FAQManager";
import FeesManager from "./component/Admin/Fees/FeesManager";
import JobListingsManager from "./component/Admin/JobListings/JobListingsManager";
import ContactInquiriesManager from "./component/Admin/ContactInquiries/ContactInquiriesManager";
import WorkWithUsManager from "./component/Admin/WorkWithUs/WorkWithUsManager";
import BlogList from "./component/Blog/BlogList";
import BlogDetail from "./component/Blog/BlogDetail";
import FAQ from "./component/FAQ/FAQ";
import Fees from "./component/Fees/Fees";
import WorkWithUs from "./component/WorkWithUs/WorkWithUs";
import ConditionsPage from "./component/Conditions/ConditionsPage";
import ContactPage from "./component/Contact/ContactPage";
import OurTeam from "./component/OurTeam/OurTeam";
import { BookingModalProvider } from "./context/BookingModalContext";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  function CommonHeader() {
    return (
      <>
        <Header />
        <Outlet />
        <Footer />
      </>
    );
  }

  function AdminRoutes() {
    return (
      <AdminLayout>
        <Outlet />
      </AdminLayout>
    );
  }

  return (
    <>
      <Provider store={store}>
        <BookingModalProvider>
          <BrowserRouter>
            <ScrollToTop />
            <Routes>
              {/* Public Routes */}
              <Route element={<CommonHeader />}>
                <Route path="/" element={<Home />} />
                <Route path="/blog" element={<BlogList />} />
                <Route path="/blog/:id" element={<BlogDetail />} />
                <Route path="/faq" element={<FAQ />} />
                <Route path="/fees" element={<Fees />} />
                <Route path="/work-with-us" element={<WorkWithUs />} />
                <Route path="/conditions" element={<ConditionsPage />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/our-team" element={<OurTeam />} />
              </Route>

              {/* Admin Routes */}
              <Route path="/admin/login" element={<Login />} />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute>
                    <AdminRoutes />
                  </ProtectedRoute>
                }
              >
                <Route index element={<Navigate to="/admin/dashboard" replace />} />
                <Route path="dashboard" element={<Dashboard />} />
                <Route path="home-content" element={<HomeContentManager />} />
                <Route path="services" element={<ServicesManager />} />
                <Route path="team" element={<TeamManager />} />
                <Route path="locations" element={<LocationsManager />} />
                <Route path="blog" element={<BlogManager />} />
                <Route path="core-values" element={<CoreValuesManager />} />
                <Route path="insurance" element={<InsuranceManager />} />
                <Route path="conditions" element={<ConditionsManager />} />
                <Route path="faq" element={<FAQManager />} />
                <Route path="fees" element={<FeesManager />} />
                <Route path="job-listings" element={<JobListingsManager />} />
                <Route path="work-with-us" element={<WorkWithUsManager />} />
                <Route path="contact-inquiries" element={<ContactInquiriesManager />} />
                <Route path="bookings" element={<BookingsManager />} />
                <Route path="settings" element={<SettingsManager />} />
              </Route>
            </Routes>
          </BrowserRouter>
        </BookingModalProvider>
      </Provider>
    </>
  );
}

export default App;
